/** @format */
import { css } from 'styled-components';

/**
 * The call to action component styles
 * */
export const styles = () => css`
    .row {
        align-items: center;
        margin: var(--layout-spacing-48) 0;
    }

    .column {
        text-align: center;
    }

    .action {
        display: block;
        margin-top: var(--layout-spacing-24);
        text-align: center;
    }

    .description {
        color: var(--colors-text-secondary);
    }
`;
